export const ContactUsIllustration = () => (
  <svg
    width="327"
    height="245"
    viewBox="0 0 327 245"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M198.351 17.0407C203.525 15.2113 209.012 14.4288 214.491 14.7386C241.672 16.4587 258.78 40.2773 263.777 65.1882C271.036 101.315 252.659 138.279 226.832 162.7C225.995 163.497 225.145 164.276 224.282 165.047C197.415 188.951 161.452 201.188 125.783 202.208C103.35 202.862 76.7327 195.269 61.9327 177.467C46.4525 158.861 49.886 116.815 79.3618 114.853C91.3692 114.049 102.566 118.411 114.128 120.804C130.158 124.127 147.607 120.909 160.759 110.935C186.919 91.1258 163.375 54.9139 179.378 31.1475C183.806 24.5552 190.738 19.7156 198.351 17.0407Z"
      fill="#6E7177"
    />
    <path
      opacity="0.95"
      d="M198.351 17.0407C203.525 15.2113 209.012 14.4288 214.491 14.7386C241.672 16.4587 258.78 40.2773 263.777 65.1882C271.036 101.315 252.659 138.279 226.832 162.7C225.995 163.497 225.145 164.276 224.282 165.047C197.415 188.951 161.452 201.188 125.783 202.208C103.35 202.862 76.7327 195.269 61.9327 177.467C46.4525 158.861 49.886 116.815 79.3618 114.853C91.3692 114.049 102.566 118.411 114.128 120.804C130.158 124.127 147.607 120.909 160.759 110.935C186.919 91.1258 163.375 54.9139 179.378 31.1475C183.806 24.5552 190.738 19.7156 198.351 17.0407Z"
      fill="#ECECEC"
    />
    <path
      d="M160 236.124C230.032 236.124 286.804 232.81 286.804 228.721C286.804 224.632 230.032 221.318 160 221.318C89.968 221.318 33.1959 224.632 33.1959 228.721C33.1959 232.81 89.968 236.124 160 236.124Z"
      fill="#F5F5F5"
    />
    <path
      d="M233.981 214.392L215.139 212.541V186.054H207.67V212.528L188.776 214.392C187.87 214.481 187.029 214.904 186.418 215.578C185.806 216.253 185.467 217.131 185.467 218.041V220.873H237.316V218.041C237.316 217.126 236.974 216.244 236.357 215.569C235.74 214.893 234.892 214.473 233.981 214.392Z"
      fill="#263238"
    />
    <path
      opacity="0.2"
      d="M233.981 214.392L215.139 212.541V186.054H207.67V212.528L188.776 214.392C187.87 214.481 187.029 214.904 186.418 215.578C185.806 216.253 185.467 217.131 185.467 218.041V220.873H237.316V218.041C237.316 217.126 236.974 216.244 236.357 215.569C235.74 214.893 234.892 214.473 233.981 214.392Z"
      fill="white"
    />
    <path
      d="M187.435 229.27C190.133 229.27 192.321 227.083 192.321 224.385C192.321 221.687 190.133 219.5 187.435 219.5C184.737 219.5 182.55 221.687 182.55 224.385C182.55 227.083 184.737 229.27 187.435 229.27Z"
      fill="#263238"
    />
    <path
      d="M235.302 229.27C238 229.27 240.187 227.083 240.187 224.385C240.187 221.687 238 219.5 235.302 219.5C232.603 219.5 230.416 221.687 230.416 224.385C230.416 227.083 232.603 229.27 235.302 229.27Z"
      fill="#263238"
    />
    <path
      d="M206.388 168.161H216.427V189.043C216.427 189.759 216.143 190.446 215.636 190.953C215.129 191.459 214.442 191.744 213.726 191.744H209.089C208.373 191.744 207.686 191.459 207.179 190.953C206.673 190.446 206.388 189.759 206.388 189.043V168.161Z"
      fill="#263238"
    />
    <path
      opacity="0.3"
      d="M206.388 168.161H216.427V189.043C216.427 189.759 216.143 190.446 215.636 190.953C215.129 191.459 214.442 191.744 213.726 191.744H209.089C208.373 191.744 207.686 191.459 207.179 190.953C206.673 190.446 206.388 189.759 206.388 189.043V168.161Z"
      fill="white"
    />
    <path
      d="M229.259 126.769C229.259 126.769 230.684 162.085 220.848 168.161H232.077C232.077 168.161 240.776 156.134 238.316 126.769H229.259Z"
      fill="#263238"
    />
    <path
      opacity="0.3"
      d="M229.259 126.769C229.259 126.769 230.684 162.085 220.848 168.161H232.077C232.077 168.161 240.776 156.134 238.316 126.769H229.259Z"
      fill="white"
    />
    <path
      d="M235.897 170.868H185.591V166.493C185.591 165.626 185.936 164.794 186.549 164.181C187.162 163.567 187.994 163.223 188.861 163.223H232.627C233.494 163.223 234.326 163.567 234.939 164.181C235.552 164.794 235.897 165.626 235.897 166.493V170.868Z"
      fill="#263238"
    />
    <path
      d="M184.806 170.868H236.675C237.401 170.868 237.99 170.279 237.99 169.553V168.363C237.99 167.637 237.401 167.049 236.675 167.049H184.806C184.08 167.049 183.492 167.637 183.492 168.363V169.553C183.492 170.279 184.08 170.868 184.806 170.868Z"
      fill="#263238"
    />
    <path
      opacity="0.6"
      d="M184.806 170.868H236.675C237.401 170.868 237.99 170.279 237.99 169.553V168.363C237.99 167.637 237.401 167.049 236.675 167.049H184.806C184.08 167.049 183.492 167.637 183.492 168.363V169.553C183.492 170.279 184.08 170.868 184.806 170.868Z"
      fill="white"
    />
    <path
      d="M241.07 107.836H223.085C217.819 107.836 213.549 112.105 213.549 117.371V124.408C213.549 129.674 217.819 133.943 223.085 133.943H241.07C246.336 133.943 250.605 129.674 250.605 124.408V117.371C250.605 112.105 246.336 107.836 241.07 107.836Z"
      fill="#263238"
    />
    <path
      d="M168.535 78.9811L164.944 69.5177C164.944 69.5177 166.488 68.092 165.428 66.6467C164.369 65.2013 157.75 61.14 156.547 61.8529C155.344 62.5657 152.656 65.2602 154.108 66.7579C155.559 68.2555 161.956 70.7473 161.956 70.7473L165.134 83.1733L168.535 78.9811Z"
      fill="#ECB1A8"
    />
    <path
      d="M193.603 96.9727C193.603 96.9727 177.253 93.6176 175.506 92.8132C173.76 92.0088 167.194 72.7616 167.194 72.7616L162.152 75.116C162.152 75.116 166.207 94.4351 170.353 99.0262C174.499 103.617 192.197 107.528 192.197 107.528L193.603 96.9727Z"
      fill="#6E7177"
    />
    <path
      opacity="0.2"
      d="M192.157 107.509L191.856 107.437C190.967 107.234 188.174 106.58 184.859 105.605C179.476 104.042 172.688 101.681 170.32 99.0328C166.18 94.4548 162.119 75.116 162.119 75.116L167.155 72.7616C167.155 72.7616 173.728 92.0153 175.506 92.8132C177.285 93.6111 193.603 96.9727 193.603 96.9727L192.157 107.509Z"
      fill="black"
    />
    <path
      d="M167.24 72.3822L168.28 74.39L161.805 76.6201L162.054 74.1676L167.24 72.3822Z"
      fill="#6E7177"
    />
    <path
      opacity="0.2"
      d="M192.281 107.24C191.379 107.11 188.547 106.671 185.159 105.932C187.089 102.597 192.739 100.884 192.739 100.884L192.281 107.24Z"
      fill="black"
    />
    <path
      d="M216.623 83.6442C216.623 83.6442 217.585 92.689 214.236 94.9126C210.888 97.1362 194.4 94.5333 192.53 90.8905C190.66 87.2477 197.697 77.3723 197.697 77.3723L216.623 83.6442Z"
      fill="#263238"
    />
    <path
      d="M149.922 202.659L154.225 203.699L156.403 197.761L158.378 192.359L153.48 190.272L151.596 196.825L149.922 202.659Z"
      fill="#ECB1A8"
    />
    <path
      opacity="0.2"
      d="M151.596 196.825L156.403 197.761L158.378 192.359L153.48 190.272L151.596 196.825Z"
      fill="black"
    />
    <path
      d="M152.028 193.693L157.992 195.91C157.992 195.91 173.904 156.127 177.174 156.016C180.444 155.905 213.739 171.182 222.084 162.693C230.429 154.204 218.363 133.734 218.363 133.734C218.363 133.734 198.292 130.869 196.781 135.402C196.409 136.738 196.125 138.097 195.931 139.47C195.702 140.856 195.545 142.02 195.545 142.02C194.924 141.863 174.774 136.664 166.834 142.02C158.757 147.468 152.028 193.693 152.028 193.693Z"
      fill="#6E7177"
    />
    <path
      opacity="0.6"
      d="M152.028 193.693L157.992 195.91C157.992 195.91 173.904 156.127 177.174 156.016C180.444 155.905 213.739 171.182 222.084 162.693C230.429 154.204 218.363 133.734 218.363 133.734C218.363 133.734 198.292 130.869 196.781 135.402C196.409 136.738 196.125 138.097 195.931 139.47C195.702 140.856 195.545 142.02 195.545 142.02C194.924 141.863 174.774 136.664 166.834 142.02C158.757 147.468 152.028 193.693 152.028 193.693Z"
      fill="white"
    />
    <path
      d="M186.337 219.63L190.62 218.538L189.796 212.384L189.031 206.747L183.734 207.224L185.107 213.797L186.337 219.63Z"
      fill="#ECB1A8"
    />
    <path
      opacity="0.2"
      d="M185.14 213.927L189.822 212.502L189.044 206.805L183.74 207.257L185.14 213.927Z"
      fill="black"
    />
    <path
      d="M160.458 193.699L151.766 190.75L151.393 194.308L157.986 196.636L160.458 193.699Z"
      fill="#6E7177"
    />
    <path
      d="M207.67 164.707C207.67 164.707 206.31 164.74 185.258 163.759C185.258 163.759 188.403 190.076 190.123 209.781L183.825 210.854C183.825 210.854 168.783 168.664 168.947 161.961C169.11 155.257 176.795 153.295 176.795 153.295C176.795 153.295 191.791 161.961 207.67 164.707Z"
      fill="#6E7177"
    />
    <path
      opacity="0.6"
      d="M207.67 164.707C207.67 164.707 206.31 164.74 185.258 163.759C185.258 163.759 188.403 190.076 190.123 209.781L183.825 210.854C183.825 210.854 168.783 168.664 168.947 161.961C169.11 155.257 176.795 153.295 176.795 153.295C176.795 153.295 191.791 161.961 207.67 164.707Z"
      fill="white"
    />
    <path
      opacity="0.1"
      d="M207.67 164.707C207.67 164.707 206.31 164.74 185.258 163.759C185.258 163.759 188.403 190.076 190.123 209.781L183.825 210.854C183.825 210.854 168.783 168.664 168.947 161.961C169.11 155.257 176.795 153.295 176.795 153.295C176.795 153.295 191.791 161.961 207.67 164.707Z"
      fill="black"
    />
    <path
      d="M191.039 207.871L182.386 208.859L184.061 212.247L191.065 211.351L191.039 207.871Z"
      fill="#6E7177"
    />
    <path
      opacity="0.1"
      d="M195.545 142.02L207.284 144.466C207.284 144.466 200.797 140.882 195.931 139.47C195.702 140.856 195.545 142.02 195.545 142.02Z"
      fill="black"
    />
    <path
      d="M217.879 130.614L218.363 133.734L196.781 135.402L196.212 131.707L217.879 130.614Z"
      fill="#263238"
    />
    <path
      opacity="0.2"
      d="M217.879 130.614L218.363 133.734L196.781 135.402L196.212 131.707L217.879 130.614Z"
      fill="black"
    />
    <path
      d="M211.072 135.841L212.139 135.731L211.581 130.299L210.514 130.409L211.072 135.841Z"
      fill="#6E7177"
    />
    <path
      d="M201.484 135.299L206.209 134.995L205.979 131.412L201.254 131.715L201.484 135.299Z"
      fill="white"
    />
    <path
      d="M197.83 136.412L198.897 136.302L198.339 130.87L197.272 130.98L197.83 136.412Z"
      fill="#6E7177"
    />
    <path
      opacity="0.6"
      d="M211.072 135.841L212.139 135.731L211.581 130.299L210.514 130.409L211.072 135.841Z"
      fill="white"
    />
    <path
      opacity="0.6"
      d="M197.83 136.412L198.897 136.302L198.339 130.87L197.272 130.98L197.83 136.412Z"
      fill="white"
    />
    <path
      d="M193.21 96.6783C197.253 97.795 201.448 98.2565 205.636 98.0452C212.569 97.692 220.822 101.034 220.822 101.034L217.853 130.595L196.179 131.687C196.179 131.687 188.926 107.025 193.21 96.6783Z"
      fill="#6E7177"
    />
    <path
      d="M196.696 79.9818C196.696 79.9818 197.912 65.633 209.907 70.8258C224.949 77.3658 212.994 94.8537 205.636 91.2698C198.279 87.6859 196.696 79.9818 196.696 79.9818Z"
      fill="#263238"
    />
    <path
      opacity="0.2"
      d="M200.057 98.8496L200.404 106.959L203.092 103.146C203.092 103.146 202.131 112.113 202.693 116.998C202.693 116.998 203.21 108.241 204.426 103.146L207.284 106.959L211.385 98.9019C211.385 98.9019 204.747 96.5148 200.057 98.8496Z"
      fill="black"
    />
    <path
      d="M203.772 100.38L209.979 98.6272C206.153 96.0112 208.082 90.1252 208.082 90.1252L201.934 92.2834C202.217 93.138 202.436 94.0124 202.588 94.8994C203.242 98.7319 201.503 99.0393 201.503 99.0393L203.772 100.38Z"
      fill="#ECB1A8"
    />
    <path
      opacity="0.2"
      d="M201.934 92.2508C202.217 93.1053 202.436 93.9797 202.588 94.8668C205.531 93.683 208.076 90.0795 208.076 90.0795L201.934 92.2508Z"
      fill="black"
    />
    <path
      d="M205.95 73.8603C200.502 72.657 198.102 75.1683 196.467 80.7012C194.42 87.6009 194.871 92.9244 202.006 92.9375C211.699 92.9506 214.988 75.8616 205.95 73.8603Z"
      fill="#ECB1A8"
    />
    <path
      d="M200.051 81.1786C199.438 81.8952 198.739 82.5343 197.971 83.0817C198.081 83.3436 198.262 83.5698 198.493 83.735C198.724 83.9001 198.996 83.9978 199.279 84.0169L200.051 81.1786Z"
      fill="#C79992"
    />
    <path
      d="M203.484 81.4663C203.373 81.911 203.524 82.3361 203.825 82.4081C204.125 82.48 204.446 82.1792 204.557 81.7541C204.668 81.329 204.518 80.8908 204.217 80.8123C203.916 80.7338 203.596 81.0216 203.484 81.4663Z"
      fill="#263238"
    />
    <path
      d="M204.335 80.845L203.465 80.2302C203.465 80.2302 203.746 81.1654 204.335 80.845Z"
      fill="#263238"
    />
    <path
      d="M197.978 80.0144C197.867 80.4591 198.017 80.8842 198.318 80.9562C198.619 81.0281 198.972 80.7273 199.05 80.3022C199.129 79.8771 199.011 79.4389 198.71 79.3604C198.41 79.2819 198.089 79.5697 197.978 80.0144Z"
      fill="#263238"
    />
    <path
      d="M198.828 79.3931L197.932 78.798C197.932 78.798 198.239 79.707 198.828 79.3931Z"
      fill="#263238"
    />
    <path
      d="M206.552 79.3016C206.508 79.3024 206.465 79.2912 206.427 79.2693C206.389 79.2475 206.357 79.2156 206.336 79.1773C206.12 78.8409 205.832 78.557 205.493 78.3465C205.153 78.136 204.771 78.0043 204.374 77.9609C204.311 77.9527 204.254 77.9212 204.214 77.8726C204.174 77.824 204.154 77.7621 204.158 77.6993C204.165 77.6362 204.196 77.5782 204.245 77.5379C204.294 77.4975 204.356 77.478 204.42 77.4835C204.902 77.5301 205.366 77.6878 205.777 77.9442C206.188 78.2007 206.534 78.5489 206.787 78.9615C206.802 78.9893 206.811 79.0198 206.813 79.0511C206.816 79.0824 206.812 79.1139 206.802 79.1438C206.793 79.1736 206.777 79.2013 206.756 79.225C206.736 79.2487 206.711 79.2681 206.683 79.282C206.641 79.2983 206.596 79.305 206.552 79.3016Z"
      fill="#263238"
    />
    <path
      d="M200.463 76.836C200.419 76.8352 200.375 76.8216 200.339 76.7967C200.017 76.6424 199.665 76.5623 199.309 76.5623C198.952 76.5623 198.6 76.6424 198.279 76.7967C198.25 76.8083 198.22 76.8141 198.189 76.8138C198.159 76.8135 198.129 76.807 198.101 76.7948C198.073 76.7826 198.047 76.7649 198.026 76.7428C198.005 76.7207 197.989 76.6945 197.978 76.6659C197.966 76.6372 197.96 76.6064 197.96 76.5753C197.961 76.5443 197.967 76.5136 197.979 76.485C197.991 76.4564 198.009 76.4306 198.031 76.4089C198.053 76.3872 198.08 76.3701 198.109 76.3585C198.499 76.1767 198.926 76.0869 199.357 76.096C199.788 76.105 200.211 76.2128 200.594 76.4109C200.62 76.4275 200.643 76.4492 200.661 76.4747C200.679 76.5002 200.691 76.5289 200.698 76.5593C200.705 76.5898 200.705 76.6212 200.7 76.6518C200.694 76.6825 200.683 76.7117 200.666 76.7379C200.642 76.7694 200.612 76.7949 200.576 76.8119C200.541 76.829 200.502 76.8373 200.463 76.836Z"
      fill="#263238"
    />
    <path
      d="M209.867 84.3504C209.867 84.3504 208.311 79.3146 209.462 75.9465C209.462 75.9465 199.652 69.1514 196.696 79.9817C196.696 79.9817 197.788 70.0278 207.199 71.8852C216.61 73.7425 213.53 87.4177 207.794 90.4261C207.794 90.4261 210.822 87.4962 209.867 84.3504Z"
      fill="#263238"
    />
    <path
      d="M208.723 85.338C208.915 84.7192 209.344 84.2016 209.916 83.8988C210.489 83.596 211.158 83.5326 211.777 83.7226C213.425 84.2785 213.458 87.9213 209.083 87.8232C208.448 87.7774 208.239 87.1169 208.723 85.338Z"
      fill="#ECB1A8"
    />
    <path
      d="M198.292 86.0835C198.437 86.7514 198.533 87.429 198.58 88.1109H198.933C200.561 88.2483 201.359 87.7709 201.751 87.2084C201.939 86.9289 202.056 86.6079 202.091 86.2732C202.119 86.0845 202.119 85.8929 202.091 85.7042C201.042 86.0658 199.927 86.1974 198.821 86.0901C198.508 86.1097 198.292 86.0835 198.292 86.0835Z"
      fill="#263238"
    />
    <path
      d="M198.848 86.1228L198.946 86.7179C200.476 86.8422 201.562 86.7179 202.091 86.3059C202.119 86.1173 202.119 85.9256 202.091 85.7369C201.05 86.0948 199.944 86.2263 198.848 86.1228Z"
      fill="white"
    />
    <path
      d="M198.933 88.1437C200.561 88.281 201.359 87.8036 201.751 87.2412C201.134 87.2009 200.514 87.2695 199.92 87.4439C199.525 87.5673 199.18 87.8122 198.933 88.1437Z"
      fill="#C79992"
    />
    <path
      d="M205.97 74.2984C205.97 74.2984 206.179 83.7357 211.856 84.8736C217.532 86.0116 211.332 72.7354 211.332 72.7354C211.332 72.7354 202.896 67.2287 197.271 71.1135C191.647 74.9982 196.709 79.9817 196.709 79.9817C196.709 79.9817 197.88 72.9708 205.97 74.2984Z"
      fill="#263238"
    />
    <path
      d="M208.134 82.9378C208.096 82.9375 208.059 82.9236 208.03 82.8986C204.001 79.7332 205.989 73.6772 206.009 73.6183C206.024 73.5774 206.054 73.5438 206.093 73.5243C206.132 73.5048 206.177 73.501 206.218 73.5137C206.259 73.5285 206.292 73.5588 206.311 73.598C206.329 73.6373 206.331 73.6822 206.316 73.723C206.316 73.7818 204.387 79.609 208.233 82.6435C208.248 82.6582 208.261 82.676 208.269 82.6956C208.278 82.7153 208.282 82.7365 208.282 82.758C208.282 82.7794 208.278 82.8007 208.269 82.8203C208.261 82.84 208.248 82.8578 208.233 82.8724C208.222 82.8896 208.207 82.9044 208.19 82.9156C208.174 82.9269 208.154 82.9345 208.134 82.9378Z"
      fill="#263238"
    />
    <path
      d="M213.497 86.8095C212.778 88.7322 210.927 89.8113 209.364 89.2293C207.801 88.6472 207.121 86.6132 207.84 84.6905C208.56 82.7677 210.41 81.6886 211.973 82.2772C213.536 82.8658 214.217 84.8932 213.497 86.8095Z"
      fill="#6E7177"
    />
    <path
      opacity="0.4"
      d="M213.497 86.8095C212.778 88.7322 210.927 89.8113 209.364 89.2293C207.801 88.6472 207.121 86.6132 207.84 84.6905C208.56 82.7677 210.41 81.6886 211.973 82.2772C213.536 82.8658 214.217 84.8932 213.497 86.8095Z"
      fill="black"
    />
    <path
      d="M211.666 83.6638C211.666 83.6638 214.014 73.154 208.749 70.4006C209.349 70.4791 209.943 70.5948 210.528 70.7473C211.182 70.9435 215.413 75.2075 213.288 84.6513L211.666 83.6638Z"
      fill="#6E7177"
    />
    <path
      opacity="0.2"
      d="M211.666 83.6638C211.666 83.6638 214.014 73.154 208.749 70.4006C209.349 70.4791 209.943 70.5948 210.528 70.7473C211.182 70.9435 215.413 75.2075 213.288 84.6513L211.666 83.6638Z"
      fill="black"
    />
    <path
      d="M201.856 89.6806L201.464 89.6218L201.568 88.9678C204.457 89.4119 207.408 88.7864 209.868 87.2085L210.253 87.7317C207.78 89.3707 204.798 90.0627 201.856 89.6806Z"
      fill="#6E7177"
    />
    <g opacity="0.2">
      <path
        d="M201.856 89.6806L201.464 89.6218L201.568 88.9678C204.457 89.4119 207.408 88.7864 209.868 87.2085L210.253 87.7317C207.78 89.3707 204.798 90.0627 201.856 89.6806Z"
        fill="black"
      />
    </g>
    <path
      d="M213.275 86.5479C212.804 87.8166 211.575 88.5099 210.548 88.1436C209.521 87.7774 209.063 86.4171 209.541 85.1483C210.018 83.8796 211.241 83.1863 212.268 83.5526C213.295 83.9188 213.752 85.2791 213.275 86.5479Z"
      fill="#6E7177"
    />
    <path
      d="M201.241 89.916L200.712 89.8441C200.619 89.832 200.53 89.8018 200.449 89.7551C200.368 89.7083 200.298 89.6461 200.241 89.5719C200.185 89.4977 200.143 89.4131 200.12 89.3228C200.096 89.2326 200.09 89.1386 200.103 89.0462C200.115 88.9531 200.144 88.8632 200.191 88.7818C200.237 88.7003 200.299 88.6288 200.373 88.5716C200.448 88.5144 200.533 88.4725 200.623 88.4485C200.714 88.4244 200.808 88.4186 200.901 88.4315L201.424 88.5034C201.611 88.5295 201.78 88.6276 201.895 88.7768C202.01 88.926 202.062 89.1143 202.039 89.3013C202.013 89.4878 201.915 89.6566 201.766 89.7716C201.617 89.8865 201.428 89.9384 201.241 89.916Z"
      fill="#6E7177"
    />
    <path
      opacity="0.4"
      d="M201.241 89.916L200.712 89.8441C200.619 89.832 200.53 89.8018 200.449 89.7551C200.368 89.7083 200.298 89.6461 200.241 89.5719C200.185 89.4977 200.143 89.4131 200.12 89.3228C200.096 89.2326 200.09 89.1386 200.103 89.0462C200.115 88.9531 200.144 88.8632 200.191 88.7818C200.237 88.7003 200.299 88.6288 200.373 88.5716C200.448 88.5144 200.533 88.4725 200.623 88.4485C200.714 88.4244 200.808 88.4186 200.901 88.4315L201.424 88.5034C201.611 88.5295 201.78 88.6276 201.895 88.7768C202.01 88.926 202.062 89.1143 202.039 89.3013C202.013 89.4878 201.915 89.6566 201.766 89.7716C201.617 89.8865 201.428 89.9384 201.241 89.916Z"
      fill="black"
    />
    <path
      d="M208.311 96.3579L204.426 100.171L205.983 104.853L211.385 98.902L208.311 96.3579Z"
      fill="#6E7177"
    />
    <path
      d="M202.693 97.1558L203.321 100.092L201.313 104.245L200.057 98.8496L202.693 97.1558Z"
      fill="#6E7177"
    />
    <path
      d="M207.48 99.6672L209.737 91.4072C209.737 91.4072 208.645 89.3536 208.88 88.922C209.115 88.4903 210.293 82.9444 211.13 82.3427C211.967 81.741 215.413 82.7678 215.76 83.3303C216.107 83.8927 212.457 91.4072 212.457 91.4072L211.149 100.36L207.48 99.6672Z"
      fill="#ECB1A8"
    />
    <path
      d="M220.822 101.034C227.035 107.391 214.589 121.792 207.454 121.177C200.319 120.562 207.637 94.4547 207.637 94.4547L212.215 95.2068C212.215 95.2068 210.613 106.508 211.117 107.391C211.62 108.274 218.762 98.9215 220.822 101.034Z"
      fill="#6E7177"
    />
    <path
      opacity="0.2"
      d="M220.822 101.034C227.035 107.391 214.589 121.792 207.454 121.177C200.319 120.562 207.637 94.4547 207.637 94.4547L212.215 95.2068C212.215 95.2068 210.613 106.508 211.117 107.391C211.62 108.274 218.762 98.9215 220.822 101.034Z"
      fill="black"
    />
    <path
      d="M207.284 93.6372L206.611 95.7954L212.974 96.3578V94.4743L207.284 93.6372Z"
      fill="#6E7177"
    />
    <path
      opacity="0.6"
      d="M197.638 110.713H195.061C194.776 110.713 194.544 110.945 194.544 111.23V116.096C194.544 116.381 194.776 116.612 195.061 116.612H197.638C197.923 116.612 198.154 116.381 198.154 116.096V111.23C198.154 110.945 197.923 110.713 197.638 110.713Z"
      fill="white"
    />
    <path
      opacity="0.2"
      d="M197.69 111.106H194.76V115.115H197.69V111.106Z"
      fill="black"
    />
    <path d="M196.617 109.294H195.97V111.655H196.617V109.294Z" fill="#263238" />
    <path
      d="M142.806 211.017C143.459 210.714 144.162 210.534 144.88 210.487C144.88 210.487 147.365 209.029 149.824 203.346H152.59C153.059 203.349 153.516 203.497 153.898 203.77C154.279 204.043 154.567 204.427 154.722 204.87C154.768 204.991 154.795 205.119 154.801 205.249C154.768 205.917 154.696 206.583 154.585 207.244C154.18 209.454 153.641 211.638 152.97 213.784L152.499 213.666L153.349 209.533C153.637 208.133 152.159 209.487 151.478 210.899C150.798 212.312 149.745 213.744 146.685 213.045C143.12 212.168 141.688 211.658 142.806 211.017Z"
      fill="#6E7177"
    />
    <path
      d="M150.327 201.861C150.327 201.861 146.868 209.094 144.88 210.487C144.88 210.487 147.548 212.077 150.327 208.525C153.918 203.947 154.801 205.223 154.801 205.223C154.725 204.433 154.579 203.651 154.363 202.888C153.826 201.423 150.327 201.861 150.327 201.861Z"
      fill="#ECB1A8"
    />
    <path
      d="M180.882 228.25C181.447 227.805 182.087 227.464 182.772 227.243C182.772 227.243 184.839 225.235 185.879 219.133L188.567 218.479C189.023 218.374 189.5 218.412 189.934 218.588C190.369 218.763 190.738 219.068 190.993 219.46C191.067 219.569 191.124 219.688 191.163 219.814C191.294 220.461 191.383 221.117 191.431 221.776C191.557 224.011 191.546 226.252 191.399 228.486H190.915L190.764 224.274C190.705 222.842 189.6 224.509 189.267 226.046C188.933 227.583 188.259 229.211 185.12 229.257C181.464 229.297 179.947 229.14 180.882 228.25Z"
      fill="#6E7177"
    />
    <path
      d="M186.016 217.57C186.016 217.57 184.375 225.418 182.746 227.243C182.746 227.243 185.715 228.158 187.573 224.058C189.979 218.761 191.137 219.794 191.137 219.794C190.878 219.044 190.552 218.32 190.162 217.629C189.312 216.321 186.016 217.57 186.016 217.57Z"
      fill="#ECB1A8"
    />
    <path
      d="M246.825 59.2761H223.994C222.163 59.2761 220.678 60.7607 220.678 62.5919V72.3561C220.678 74.1874 222.163 75.6719 223.994 75.6719H246.825C248.656 75.6719 250.141 74.1874 250.141 72.3561V62.5919C250.141 60.7607 248.656 59.2761 246.825 59.2761Z"
      fill="#6E7177"
    />
    <path
      d="M228.572 73.8015L221.692 83.1537L232.79 74.4294L228.572 73.8015Z"
      fill="#6E7177"
    />
    <path
      d="M228.827 67.4708C228.828 67.6628 228.772 67.8508 228.667 68.011C228.561 68.1712 228.41 68.2962 228.232 68.3703C228.055 68.4444 227.86 68.4641 227.672 68.427C227.483 68.3898 227.31 68.2975 227.175 68.1617C227.039 68.026 226.947 67.8529 226.909 67.6645C226.872 67.4762 226.892 67.281 226.966 67.1039C227.04 66.9268 227.165 66.7757 227.325 66.6698C227.486 66.564 227.674 66.5081 227.866 66.5094C228.121 66.5094 228.365 66.6107 228.545 66.791C228.726 66.9713 228.827 67.2158 228.827 67.4708Z"
      fill="white"
    />
    <path
      d="M233.856 67.4708C233.858 67.6628 233.802 67.8508 233.696 68.011C233.59 68.1712 233.439 68.2962 233.262 68.3703C233.085 68.4444 232.889 68.4641 232.701 68.427C232.513 68.3898 232.34 68.2975 232.204 68.1617C232.068 68.026 231.976 67.8529 231.939 67.6645C231.902 67.4762 231.921 67.281 231.995 67.1039C232.069 66.9268 232.194 66.7757 232.355 66.6698C232.515 66.564 232.703 66.5081 232.895 66.5094C233.15 66.5094 233.394 66.6107 233.575 66.791C233.755 66.9713 233.856 67.2158 233.856 67.4708Z"
      fill="white"
    />
    <path
      d="M238.886 67.4708C238.887 67.6628 238.831 67.8508 238.725 68.011C238.619 68.1712 238.468 68.2962 238.291 68.3703C238.114 68.4444 237.919 68.4641 237.73 68.427C237.542 68.3898 237.369 68.2975 237.233 68.1617C237.097 68.026 237.005 67.8529 236.968 67.6645C236.931 67.4762 236.951 67.281 237.025 67.1039C237.099 66.9268 237.224 66.7757 237.384 66.6698C237.544 66.564 237.732 66.5081 237.924 66.5094C238.179 66.5094 238.424 66.6107 238.604 66.791C238.784 66.9713 238.886 67.2158 238.886 67.4708Z"
      fill="white"
    />
    <path
      d="M243.915 67.4708C243.916 67.6628 243.86 67.8508 243.754 68.011C243.648 68.1712 243.497 68.2962 243.32 68.3703C243.143 68.4444 242.948 68.4641 242.76 68.427C242.571 68.3898 242.398 68.2975 242.262 68.1617C242.127 68.026 242.034 67.8529 241.997 67.6645C241.96 67.4762 241.98 67.281 242.054 67.1039C242.128 66.9268 242.253 66.7757 242.413 66.6698C242.573 66.564 242.761 66.5081 242.953 66.5094C243.208 66.5094 243.453 66.6107 243.633 66.791C243.813 66.9713 243.915 67.2158 243.915 67.4708Z"
      fill="white"
    />
    <path d="M114.096 119.372H89.2699V124.46H114.096V119.372Z" fill="white" />
    <path
      opacity="0.1"
      d="M114.096 119.372H89.2699V124.46H114.096V119.372Z"
      fill="black"
    />
    <path
      opacity="0.1"
      d="M99.7274 119.372H89.2699V124.46H99.7274V119.372Z"
      fill="black"
    />
    <path
      opacity="0.1"
      d="M89.2699 120.105H111.369L89.2699 120.732V120.105Z"
      fill="black"
    />
    <path
      opacity="0.1"
      d="M114.096 120.988L94.9402 121.465H114.096V120.988Z"
      fill="black"
    />
    <path
      opacity="0.1"
      d="M90.2837 122.413L99.7275 122.027L113.612 122.413L99.7275 122.629L90.2837 122.413Z"
      fill="black"
    />
    <path
      opacity="0.1"
      d="M89.2699 123.492H105.633L89.2699 123.878V123.492Z"
      fill="black"
    />
    <path
      opacity="0.1"
      d="M114.057 123.878L103.128 124.081H114.096L114.057 123.878Z"
      fill="black"
    />
    <path d="M110.643 114.284H85.8169V119.372H110.643V114.284Z" fill="white" />
    <path
      opacity="0.1"
      d="M110.643 114.284H85.8169V119.372H110.643V114.284Z"
      fill="black"
    />
    <path
      opacity="0.1"
      d="M96.2743 114.284H85.8169V119.372H96.2743V114.284Z"
      fill="black"
    />
    <path
      opacity="0.1"
      d="M85.8169 115.016H107.916L85.8169 115.638V115.016Z"
      fill="black"
    />
    <path
      opacity="0.1"
      d="M110.643 115.899L91.4871 116.377H110.643V115.899Z"
      fill="black"
    />
    <path
      opacity="0.1"
      d="M86.824 117.325L96.2677 116.933L110.152 117.325L96.2677 117.541L86.824 117.325Z"
      fill="black"
    />
    <path
      opacity="0.1"
      d="M85.8169 118.398H102.18L85.8169 118.79V118.398Z"
      fill="black"
    />
    <path
      opacity="0.1"
      d="M110.603 118.79L99.675 118.993H110.643L110.603 118.79Z"
      fill="black"
    />
    <path d="M113.475 109.189H88.6487V114.278H113.475V109.189Z" fill="white" />
    <path
      opacity="0.1"
      d="M113.475 109.189H88.6487V114.278H113.475V109.189Z"
      fill="black"
    />
    <path
      opacity="0.1"
      d="M99.1061 109.189H88.6487V114.278H99.1061V109.189Z"
      fill="black"
    />
    <path
      opacity="0.1"
      d="M88.6487 109.922H110.747L88.6487 110.55V109.922Z"
      fill="black"
    />
    <path
      opacity="0.1"
      d="M113.475 110.805L94.3188 111.282H113.475V110.805Z"
      fill="black"
    />
    <path
      opacity="0.1"
      d="M89.6624 112.23L99.1061 111.845L112.991 112.23L99.1061 112.446L89.6624 112.23Z"
      fill="black"
    />
    <path
      opacity="0.1"
      d="M88.6487 113.31H105.012L88.6487 113.695V113.31Z"
      fill="black"
    />
    <path
      opacity="0.1"
      d="M113.442 113.695L102.513 113.898H113.474L113.442 113.695Z"
      fill="black"
    />
    <path
      d="M130.014 124.356L130.655 121.916H157.181L169.391 123.139L169.856 124.356H130.014Z"
      fill="#263238"
    />
    <path
      opacity="0.4"
      d="M157.181 121.916V124.356H130.014L130.655 121.916H157.181Z"
      fill="black"
    />
    <path
      d="M151.851 110.242C151.887 110.538 151.859 110.838 151.768 111.122C151.678 111.406 151.529 111.667 151.329 111.888C151.13 112.11 150.885 112.286 150.612 112.404C150.339 112.523 150.043 112.582 149.745 112.577H109.119C108.484 112.563 107.875 112.319 107.407 111.889C106.939 111.459 106.643 110.874 106.575 110.242L104.162 84.2328C104.135 83.9787 104.153 83.7221 104.214 83.4741C104.327 83.0174 104.591 82.6126 104.964 82.3261C105.338 82.0397 105.797 81.8887 106.267 81.898H146.92C147.555 81.9118 148.164 82.1563 148.632 82.586C149.1 83.0156 149.396 83.601 149.464 84.2328L151.851 110.242Z"
      fill="#263238"
    />
    <path
      opacity="0.4"
      d="M149.601 112.577H109.119C108.484 112.563 107.875 112.319 107.407 111.889C106.939 111.459 106.643 110.874 106.575 110.242L104.161 84.2328C104.135 83.9788 104.153 83.7221 104.214 83.4741H144.696C145.332 83.4879 145.94 83.7325 146.408 84.1621C146.877 84.5918 147.172 85.1771 147.24 85.8089L149.654 111.818C149.68 112.073 149.662 112.329 149.601 112.577Z"
      fill="black"
    />
    <path
      d="M121.689 96.6261H130.093L127.856 120.687L141.145 122.681V124.356H113.154V122.681L118.89 120.687L121.689 96.6261Z"
      fill="#263238"
    />
    <path
      opacity="0.1"
      d="M130.093 96.6261L123.867 123.976L118.89 123.826L121.689 96.6261H130.093Z"
      fill="white"
    />
    <path
      d="M130.053 229.264H126.051L118.85 129.038H124.167L130.053 229.264Z"
      fill="#263238"
    />
    <path
      opacity="0.4"
      d="M130.06 229.264H126.051L119.203 134.022L118.85 129.202H124.167L124.455 134.022L130.06 229.264Z"
      fill="white"
    />
    <path
      opacity="0.2"
      d="M124.455 133.78H119.203L118.85 129.202H124.167L124.455 133.78Z"
      fill="black"
    />
    <path
      d="M159.457 229.264H155.455L154.801 129.038H160.111L159.457 229.264Z"
      fill="#263238"
    />
    <path
      opacity="0.5"
      d="M160.118 129.202L160.013 145.375L159.464 229.264H155.455L154.905 145.375L154.801 129.202H160.118Z"
      fill="white"
    />
    <path
      opacity="0.2"
      d="M160.118 129.202L160.013 145.552H154.905L154.801 129.202H160.118Z"
      fill="black"
    />
    <path
      d="M201.993 229.264H197.991L190.79 129.038H196.107L201.993 229.264Z"
      fill="#263238"
    />
    <path
      opacity="0.5"
      d="M202 229.264H197.991L191.144 134.022L190.79 129.202H196.107L196.395 134.022L202 229.264Z"
      fill="white"
    />
    <path
      opacity="0.2"
      d="M196.395 133.78H191.144L190.79 129.202H196.107L196.395 133.78Z"
      fill="black"
    />
    <path
      d="M84.2211 229.264H80.2186L86.1046 129.038H91.4217L84.2211 229.264Z"
      fill="#263238"
    />
    <path
      opacity="0.5"
      d="M91.4217 129.202L91.0685 134.022L84.2211 229.264H80.2186L85.8169 134.022L86.1046 129.202H91.4217Z"
      fill="white"
    />
    <path
      opacity="0.2"
      d="M86.1046 129.202H91.4217L91.0685 133.78H85.8169L86.1046 129.202Z"
      fill="black"
    />
    <path
      d="M81.8928 126.54H200.319V130.144C200.319 130.329 200.283 130.513 200.212 130.684C200.141 130.856 200.037 131.011 199.905 131.142C199.774 131.274 199.618 131.378 199.447 131.449C199.276 131.52 199.092 131.556 198.906 131.556H83.3055C82.9308 131.556 82.5715 131.407 82.3066 131.142C82.0417 130.878 81.8928 130.518 81.8928 130.144V126.54Z"
      fill="#6E7177"
    />
    <path
      opacity="0.6"
      d="M81.8928 126.54H200.319V130.144C200.319 130.329 200.283 130.513 200.212 130.684C200.141 130.856 200.037 131.011 199.905 131.142C199.774 131.274 199.618 131.378 199.447 131.449C199.276 131.52 199.092 131.556 198.906 131.556H83.3055C82.9308 131.556 82.5715 131.407 82.3066 131.142C82.0417 130.878 81.8928 130.518 81.8928 130.144V126.54Z"
      fill="white"
    />
    <path
      opacity="0.2"
      d="M200.319 126.533H81.8928V129.045H200.319V126.533Z"
      fill="black"
    />
    <path
      d="M202.804 127.194H79.4076C79.033 127.194 78.6737 127.045 78.4087 126.78C78.1438 126.515 77.995 126.156 77.995 125.781C77.995 125.406 78.1436 125.046 78.4083 124.78C78.6731 124.514 79.0324 124.364 79.4076 124.362H202.804C203.18 124.364 203.539 124.514 203.804 124.78C204.068 125.046 204.217 125.406 204.217 125.781C204.217 126.156 204.068 126.515 203.803 126.78C203.538 127.045 203.179 127.194 202.804 127.194Z"
      fill="#6E7177"
    />
    <path
      opacity="0.6"
      d="M202.804 127.194H79.4076C79.033 127.194 78.6737 127.045 78.4087 126.78C78.1438 126.515 77.995 126.156 77.995 125.781C77.995 125.406 78.1436 125.046 78.4083 124.78C78.6731 124.514 79.0324 124.364 79.4076 124.362H202.804C203.18 124.364 203.539 124.514 203.804 124.78C204.068 125.046 204.217 125.406 204.217 125.781C204.217 126.156 204.068 126.515 203.803 126.78C203.538 127.045 203.179 127.194 202.804 127.194Z"
      fill="white"
    />
    <path
      d="M173.61 120L175.127 117.724C175.277 117.501 175.479 117.317 175.716 117.191C175.954 117.064 176.218 116.998 176.487 116.998H178.41C178.57 116.999 178.728 117.023 178.881 117.07L185.741 119.15C186.131 119.266 186.463 119.525 186.67 119.876L187.658 121.53L173.61 120Z"
      fill="#6E7177"
    />
    <path
      opacity="0.2"
      d="M187.658 121.53L177.658 120.445L173.597 120L175.114 117.724C175.263 117.501 175.466 117.317 175.703 117.191C175.94 117.064 176.205 116.998 176.474 116.998H178.397C178.559 116.999 178.72 117.023 178.874 117.07L179.025 117.116L185.728 119.15C186.12 119.265 186.454 119.525 186.664 119.876L187.658 121.53Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M187.658 121.53L177.658 120.445L179.025 117.116L185.728 119.15C186.121 119.265 186.455 119.525 186.664 119.876L187.658 121.53Z"
      fill="black"
    />
    <path
      d="M192.406 124.14V124.356H171.203L171.988 121.288C172.133 120.725 172.463 120.226 172.923 119.871C173.384 119.516 173.95 119.324 174.532 119.326H183.937C184.249 119.325 184.559 119.38 184.852 119.49L186.029 119.928L190.699 121.668C191.203 121.855 191.637 122.192 191.943 122.634C192.248 123.077 192.41 123.602 192.406 124.14Z"
      fill="#6E7177"
    />
    <path
      opacity="0.2"
      d="M192.406 124.14V124.356H183.701L184.165 121.04C184.195 120.834 184.271 120.638 184.386 120.465C184.502 120.293 184.655 120.148 184.833 120.042C185.012 119.936 185.212 119.871 185.419 119.853C185.626 119.834 185.835 119.862 186.029 119.935L190.699 121.674C191.202 121.861 191.635 122.197 191.941 122.638C192.246 123.079 192.408 123.603 192.406 124.14Z"
      fill="black"
    />
    <path
      d="M185.055 122.106L187.828 113.794C187.855 113.709 187.9 113.631 187.96 113.566C188.021 113.5 188.095 113.449 188.177 113.415C188.259 113.382 188.348 113.367 188.437 113.371C188.526 113.375 188.612 113.399 188.691 113.44C188.812 113.509 188.907 113.615 188.964 113.742C189.02 113.869 189.034 114.011 189.005 114.147L186.67 123.015C186.67 123.015 185.12 123.643 185.055 122.106Z"
      fill="#263238"
    />
    <path
      opacity="0.2"
      d="M173.61 123.669H172.38L172.616 122.459H173.845L173.61 123.669Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M175.441 123.623H174.211L174.447 122.413H175.676L175.441 123.623Z"
      fill="black"
    />
  </svg>
);
